// extracted by mini-css-extract-plugin
export var divider = "_vq-0";